
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Bourges dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Bourges certifiée Google Partner, accompagne les entreprises berruyères pour booster leur visibilité en ligne et attirer davantage de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Bourges dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Bourges certifiée Google Partner, accompagne les entreprises berruyères pour booster leur visibilité en ligne et attirer davantage de clients.",
        },
      ],
    };
  },
};
